// vh unit fix is for iOS safari
// vh unit fix is for layouts that need to normalize for the presence or absence of a scrollbar
// https://css-tricks.com/the-trick-to-viewport-units-on-mobile/

import { debounce } from 'lodash';
export function vhUnitInitial() {
    vhUnitUpdate();
    window.addEventListener(
        'resize',
        debounce(() => {
            vhUnitUpdate();
        }, 100)
    );
    // Dispatching this event because some browsers don't force a repaint when the css property changes, on load
    window.dispatchEvent(new Event('resize'));
}

// vh units updated on resize (which happens on scroll in some mobile browsers) so the elements might jump
export function vhUnitUpdate() {
    const curVh = parseFloat(getComputedStyle(document.documentElement).getPropertyValue('--vh'));
    const vh = window.innerHeight / 100;
    if (!curVh || Math.abs(curVh - vh) > 1) {
        document.documentElement.style.setProperty('--vh', `${vh}px`);
    }
}

// vw unit fix required due to scrollbar interfering with width
export function vwUnitInitial() {
    vwUnitUpdate();
    window.addEventListener(
        'resize',
        debounce(() => {
            vwUnitUpdate();
        }, 100)
    );
    window.dispatchEvent(new Event('resize'));
}

export function vwUnitUpdate() {
    const vw = document.documentElement.clientWidth / 100;
    document.documentElement.style.setProperty('--vw', `${vw}px`);
}